<template>
	<div>
		<el-button type="primary" @click="detail()">新建套餐</el-button>
		<el-table :data="tableData" highlight-current-row
			:header-cell-style="{'text-align':'center','background-color':'#ebebeb','color':'#333333','font-size':'18px'}"
			:cell-style="{'text-align':'center','font-size':'16px'}" style="margin-top: 30px;">
			<el-table-column prop="id" label="id"></el-table-column>
			<el-table-column prop="name" label="套餐名"></el-table-column>
			<el-table-column prop="price" label="价格">
				<template slot-scope="scope">
					￥{{(scope.row.price/100).toFixed(2)}}
				</template>
			</el-table-column>
			<el-table-column prop="storeList" label="适用门店"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="detail(scope.row.id)">编辑</el-button>
					<!-- <el-button type="text" style="color: red;">删除</el-button> -->
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList() {
				this.$http.get("dProductGroup/list").then(res => {
					this.tableData = res.body.data
				})
			},
			detail(id) {
				this.$router.push({
					path: "/productGroupDetail",
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<style>

</style>